<template>
  <div>
    <h1 class="page-header">{{ $t('category.category') }}</h1>
    <div class="row">
      <div class="col-lg-3 col-md-3 col-sm-12">
        <ts-card>
          <ts-card-wrapper>
            <div class="form-group m-b-15">
              <label class="form-col-label">{{ $t('category.nameKh') }}</label>
              <input
                v-model="model.category_name_kh"
                type="text"
                class="form-control kh-font"
                :class="{ 'is-invalid': errors.has('category_name_kh') }"
                :placeholder="$t('category.enterCategoryNameKh')"
              />
              <div
                class="invalid-feedback"
                v-if="errors.has('category_name_kh')"
              >
                {{ errors.first('category_name_kh') }}
              </div>
            </div>
            <div class="form-group">
              <label class="required">{{ $t('category.nameEn') }}</label>
              <input
                v-model="model.category_name_en"
                type="text"
                class="form-control"
                :class="{ 'is-invalid': errors.has('category_name_en') }"
                :placeholder="$t('category.enterCategoryNameEn')"
              />
              <div
                class="invalid-feedback"
                v-if="errors.has('category_name_en')"
              >
                {{ errors.first('category_name_en') }}
              </div>
            </div>
            <div class="form-group">
              <label class="required">{{ $t('category.code') }}</label>
              <input
                v-model="model.category_code"
                type="text"
                class="form-control"
                :class="{ 'is-invalid': errors.has('category_code') }"
                :placeholder="$t('category.entercategoryCode')"
              />
              <div class="invalid-feedback" v-if="errors.has('category_code')">
                {{ errors.first('category_code') }}
              </div>
            </div>
            <div class="form-group">
              <label class="form-col-label">{{
                $t('category.visiblein')
              }}</label>
              <select
                v-model="model.visible_in"
                class="form-control"
                :class="{ 'is-invalid': errors.has('visible_in') }"
              >
                <option value="">{{ $t('select') }}</option>
                <option value="Study Material">{{
                  $t('category.studyMaterial')
                }}</option>
                <option value="Other Material">{{
                  $t('category.otherMaterial')
                }}</option>
              </select>
              <div class="invalid-feedback" v-if="errors.has('visible_in')">
                {{ errors.first('visible_in') }}
              </div>
            </div>
            <div class="form-group">
              <label class="form-col-label">{{
                $t('category.description')
              }}</label>
              <textarea
                v-model="model.category_description"
                rows="3"
                class="form-control"
                :class="{ 'is-invalid': errors.has('category_description') }"
                :placeholder="$t('category.enterDescriptionHere')"
              ></textarea>
              <div
                class="invalid-feedback"
                v-if="errors.has('category_description')"
              >
                {{ errors.first('category_description') }}
              </div>
            </div>
            <div class="text-right">
              <ts-button v-if="updating" class="mr-2" @click.prevent="cancel">
                {{ $t('cancel') }}
              </ts-button>
              <ts-button
                v-if="updating"
                class="btn-primary"
                :waiting="waiting"
                @click.prevent="update"
              >
                {{ $t('update') }}
              </ts-button>
              <ts-button
                v-if="!updating"
                :waiting="waiting"
                class="btn-primary"
                @click.prevent="store"
                >{{ $t('Save') }}</ts-button
              >
            </div>
          </ts-card-wrapper>
        </ts-card>
      </div>
      <div class="col-lg-9 col-md-9 col-sm-12">
        <data-table :fetch="fetch" @fetched="fetch = false"></data-table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import DataTable from './table'
import { Errors } from 'form-backend-validation'

export default {
  name: 'category-form',
  components: {
    DataTable
  },
  data() {
    return {
      model: {
        category_id: '',
        category_name_kh: '',
        category_name_en: '',
        category_code: '',
        visible_in: '',
        category_description: ''
      },
      errors: new Errors(),
      waiting: false,
      fetch: false,
      updating: false
    }
  },
  created() {
    this.setEditData()
  },
  computed: {
    ...mapState('category', ['edit_data'])
  },
  methods: {
    store() {
      this.errors = new Errors()
      this.waiting = true
      this.$store
        .dispatch('category/store', this.model)
        .then(response => {
          this.clearInput()
          this.$toasted.success(response.message)
          this.waiting = false
          this.fetch = true
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
          this.waiting = false
        })
    },
    update() {
      this.errors = new Errors()
      this.waiting = true
      this.$store
        .dispatch('category/update', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.waiting = false
          this.fetch = true
          this.cancel()
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
          this.waiting = false
        })
    },

    cancel() {
      this.updating = false
      this.$store.commit('category/SET_EDIT_DATA', {})
      this.$router.push({ name: 'category' })
      this.clearInput()
    },
    clickBackURL() {
      this.$store.commit('category/SET_EDIT_DATA', {})
      this.clearInput()
      this.fetch = true
      this.updating = false
    },
    setEditData() {
      if (!_.isEmpty(this.edit_data)) {
        this.errors = new Errors()
        this.model = _.clone(this.edit_data)
        this.updating = true
      }
    },
    clearInput() {
      this.model = {
        category_id: '',
        category_name_kh: '',
        category_name_en: '',
        category_code: '',
        visible_in: '',
        category_description: ''
      }
    }
  },
  watch: {
    edit_data: {
      handler() {
        this.setEditData()
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params)) {
      this.$store.commit('category/RESET_STATE')
      this.clickBackURL()
    }
    next()
  }
}
</script>
